import { SafePipe } from '@adaptiva/core/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { IconComponent } from '@adaptiva/widgets/icon';
import { SignpostComponentModule } from '@adaptiva/widgets/signpost';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthoringPropertyLabelComponent } from './authoring-property-label.component';

@NgModule({
	imports: [
		ButtonComponentModule,
		CommonModule,
		ContainerComponentModule,
		IconComponent,
		SafePipe,
		SignpostComponentModule,
		TextComponentModule,
	],
	declarations: [AuthoringPropertyLabelComponent],
	exports: [AuthoringPropertyLabelComponent]
})
export class AuthoringPropertyLabelComponentModule {

}
